
import AssistClasses from './AssistClasses.js'

function createSteps (cxt) {
  var steps = []
  const rule = v => !!v || 'Введите значение'

  new AssistClasses.Step(
    'Укажите должника',
    (step) => `Инн: ${step.formatField('companyInn')}`,
    {
      scheme: [
        {
          fieldType: 'v-text-field',
          label: 'Инн контрагента',
          name: 'companyInn',
          grow: true,
          size: {sm8: true, xs6: true}
        },
        {
          fieldType: 'v-btn',
          slot: 'Выбрать',
          events: {'click': cxt.selectCompany},
          shrink: true,
          size: {sm4: true, xs6: true}
        }
      ]
    },
    {
      companyInn: null,
      refCode: null
    }).addToArray(steps)

  new AssistClasses.Step(
    'Укажите вид, название, номер и дату договора',
    (step) => `Договор № ${step.formatField('agreementNumber')} от ${step.formatField('agreementDate')}: ${step.formatField('agreementName')}`,
    {
      scheme: [
        {
          fieldType: 'v-select',
          label: 'Тип договора',
          name: 'agreementType',
          itemText: 'text',
          itemValue: 'value',
          items: [
            {
              text: 'Договор поставки',
              value: 1
            },
            {
              text: 'type2',
              value: 2
            }
          ],
          sm12: true
        },
        {
          fieldType: 'v-text-field',
          label: 'Название договора',
          name: 'agreementName',
          sm12: true
        },
        {
          fieldType: 'v-text-field',
          label: 'Номер договора',
          name: 'agreementNumber'
        },
        {
          fieldType: 'v-date-field',
          label: 'Дата договора',
          name: 'agreementDate',
          rules: Array.of(rule)
        }
      ]
    },
    {
      agreementType: 1,
      agreementName: null,
      agreementNumber: null,
      agreementDate: null
    }

    ).addToArray(steps)

  new AssistClasses.Step(
    'Сообщите, Основные положения договора',
    null,
    {
      scheme: [
        {
          fieldType: 'v-text-field',
          label: 'Пункт о предмете договора (п. 1.1)',
          name: 'agreement_topic_title1',
          xs12: true
        },
        {
          fieldType: 'v-textarea',
          label: 'Выдержка о предмете договора',
          rows: 5,
          name: 'agreement_topic_content1',
          xs12: true
        },
        {
          fieldType: 'v-text-field',
          label: 'Пункт о доставке (п. 1.2)',
          name: 'agreement_topic_title2',
          xs12: true
        },
        {
          fieldType: 'v-textarea',
          label: 'Выдержка о доставке',
          rows: 5,
          name: 'agreement_topic_content2',
          xs12: true
        },
        {
          fieldType: 'v-text-field',
          label: 'Пункт о подтверждающих документах (п. 1.3)',
          name: 'agreement_topic_title3',
          xs12: true
        },
        {
          fieldType: 'v-textarea',
          label: 'Выдержка о подтверждающих документах',
          rows: 5,
          name: 'agreement_topic_content3',
          xs12: true
        },
        {
          fieldType: 'v-text-field',
          label: 'Пункт о подтверждении выполнения обязательств (п. 1.4)',
          name: 'agreement_topic_title4',
          xs12: true
        },
        {
          fieldType: 'v-textarea',
          label: 'Выдержка о подтверждении выполнения обязательств',
          rows: 5,
          name: 'agreement_topic_content4',
          xs12: true
        },
        {
          fieldType: 'v-text-field',
          label: 'Пункт о праве собственности (п. 1.5)',
          name: 'agreement_topic_title5',
          xs12: true
        },
        {
          fieldType: 'v-textarea',
          label: 'Выдержка о праве собственности',
          rows: 5,
          name: 'agreement_topic_content5',
          xs12: true
        }
      ]
    },
    {
      'agreement_topic_title1': null,
      'agreement_topic_content1': null,
      'agreement_topic_title2': null,
      'agreement_topic_content2': null,
      'agreement_topic_title3': null,
      'agreement_topic_content3': null,
      'agreement_topic_title4': null,
      'agreement_topic_content4': null,
      'agreement_topic_content5': null
    }
    ).addToArray(steps)

  new AssistClasses.Step(
    'Сообщите, Ваша компания была Поставщиком/Продавцом товара либо приобрела права требования по договору цессии или в результате правопреемства',
    (step) => {
      switch (step.model.clientRole) {
        case 1:
          return 'Мы были Поставщиком/Продавцом товара'
        case 2:
          return 'Мы приобрели права требования к должнику по вышеуказанному договору на основании договора цессии'
        case 3:
          return 'Мы приобрели права требования к должнику по вышеуказанному договору в связи с правопреемством (реорганизацией юридических лиц)'
      }
    },
    {
      scheme: [
        {
          fieldType: 'v-select-radio',
          name: 'clientRole',
          itemText: 'text',
          itemValue: 'value',
          items: [
            {value: 1, text: 'Мы были Поставщиком/Продавцом товара'},
            {value: 2, text: 'Мы приобрели права требования к должнику по вышеуказанному договору на основании договора цессии (Вам надо будет предоставить Системе этот договор цессии)'},
            {value: 3, text: 'Мы приобрели права требования к должнику по вышеуказанному договору в связи с правопреемством (реорганизацией юридических лиц) (Вам надо будет предоставить Системе доказательства реорганизации)'}
          ],
          sm12: true
        }
      ]
    },
    {
      clientRole: 1
    }
    ).addToArray(steps)

  new AssistClasses.Step(
    'Сообщите на основании, какого объема документов следует рассчитать сумму долга и составить претензию',
    (step) => `Сумма по накладным ${step.formatField('consignment_sum')} руб. Сумма по платежкам ${step.formatField('payment_sum')}  руб.`,
    {
      scheme: [
        {
          fieldType: 'v-select-radio',
          name: 'invoicesCountType',
          itemText: 'text',
          itemValue: 'value',
          items: [
            {value: 1, text: 'я предоставлю Системе только неоплаченные должником накладные, взыскать долг надо только по ним'},
            {value: 2, text: 'я затрудняюсь определить оплаченные и неоплаченные накладные, Системе следует рассчитать сумму долга целиком по договору'}
          ],
          sm12: true
        },
        {
          fieldType: 'v-text-field',
          label: 'Сумма по накладным',
          name: 'consignment_sum',
          xs12: true,
          sm6: true
        },
        {
          fieldType: 'v-text-field',
          label: 'Сумма по платежкам',
          name: 'payment_sum',
          xs12: true,
          sm6: true
        }
      ]
    },
    {
      invoicesCountType: 1,
      consignment_sum: null,
      payment_sum: null
    }
    ).addToArray(steps)

  new AssistClasses.Step(
    'Укажите, что надо взыскать с должника',
    (step) => {
      switch (step.model.debtType) {
        case 1:
          return 'Только долг'
        case 2:
          return 'Только неустойку'
        case 3:
          return 'Долг и неустойку'
      }
    },
    {
      scheme: [
        {
          fieldType: 'v-select-radio',
          name: 'debtType',
          itemText: 'text',
          itemValue: 'value',
          items: [
            {value: 1, text: 'Только долг за поставку товара'},
            {value: 2, text: 'Только неустойку'},
            {value: 3, text: 'Долг и неустойку'}
          ],
          sm12: true
        }
      ]
    },
    {
      debtType: 1
    }
    ).addToArray(steps)

  const claimIsGoodsReturned = (model, field) => model['claimIsGoodsReturned'] === 1

  new AssistClasses.Step(
    'Сообщите, был ли осуществлен возврат товара',
    (step) => step.model.claimIsGoodsReturned === 1 ? `Да, Сумма возврата ${step.formatField('return_sum')}  руб.` : 'Нет',
    {
      scheme: [
        {
          fieldType: 'v-select-radio',
          name: 'claimIsGoodsReturned',
          itemText: 'text',
          itemValue: 'value',
          items: [
            {value: 1, text: 'Да (Вам надо будет предоставить Системе накладные на возврат товара)'},
            {value: 2, text: 'Нет'}
          ],
          sm12: true
        },
        {
          fieldType: 'v-text-field',
          label: 'Сумма возврата',
          name: 'return_sum',
          xs12: true,
          sm6: true,
          if: claimIsGoodsReturned
        }
      ]
    },
    {
      claimIsGoodsReturned: 2,
      return_sum: null
    }
    ).addToArray(steps)

  const claimIsSetOff = (model, field) => model['claimIsSetOff'] === 1

  new AssistClasses.Step(
    'Сообщите, была ли осуществлена частичная оплата товара путем зачета',
    (step) => step.model.claimIsSetOff === 1 ? `Да, Сумма зачета ${step.formatField('setoff_sum')} руб.` : 'Нет',
    {
      scheme: [
        {
          fieldType: 'v-select-radio',
          name: 'claimIsSetOff',
          itemText: 'text',
          itemValue: 'value',
          items: [
            {value: 1, text: 'Да (Вам надо будет предоставить Системе соглашение/уведомление о зачете с доказательством ее го получения должником)'},
            {value: 2, text: 'Нет'}
          ],
          sm12: true
        },
        {
          fieldType: 'v-text-field',
          label: 'Сумма зачета',
          name: 'setoff_sum',
          xs12: true,
          sm6: true,
          if: claimIsSetOff
        }
      ]
    },
    {
      claimIsSetOff: 1,
      setoff_sum: null
    }
    ).addToArray(steps)

  new AssistClasses.Step(
    'Сообщите, как рассчитывать сумму долга и пункт договора, в котором указано это условие (если есть такой пункт)',
    (step) => {
      switch (step.model.agreementSumCalcType) {
        case 1:
          return 'Сначала неустойка'
        case 2:
          return 'Сначала долг'
      }
    },
    {
      scheme: [
        {
          fieldType: 'v-select-radio',
          name: 'agreementSumCalcType',
          itemText: 'text',
          itemValue: 'value',
          items: [
            {value: 1, text: 'полученная оплата засчитывается в счет погашения суммы долга, а потом в счет погашения неустойки'},
            {value: 2, text: 'полученная оплата подлежит зачету в счет погашения неустойки, а потом в счет погашения суммы долга'}
          ]
        },
        {
          fieldType: 'v-text-field',
          label: '№ пункта договора',
          name: 'agreementSumCalcTopic',
          xs12: true,
          shrink: true
        }
      ]
    },
    {
      agreementSumCalcType: 1,
      agreementSumCalcTopic: '5.1'
    }
    ).addToArray(steps)

  const dependOnInterval = (model, field) => model['agreementPercentCalcType'] !== 1
  const notDependOnInterval = (model, field) => model['agreementPercentCalcType'] === 1

  new AssistClasses.Step(
    'Укажите процент неустойки по договору и номер пункта договора, содержащий это условие',
    (step) => {
      if (step.model.agreementPercentCalcType === 1) {
        if (step.model.agreementPercentCalc) {
          return `${step.model.agreementPercentCalc} % годовых`
        }
        return ''
      }
      var result = ''
      if (step.model.agreementPercentDays1) {
        result = `Просрочка ${step.model.agreementPercentDays1} дней - ${step.formatField('agreementPercentCalc1')} % годовых`
      }
      if (step.model.agreementPercentDays2) {
        result = result.concat(`, ${step.model.agreementPercentDays2} дней - ${step.formatField('agreementPercentCalc2')} % годовых`)
      }
      if (step.model.agreementPercentDays3) {
        result = result.concat(`, ${step.model.agreementPercentDays3} дней - ${step.formatField('agreementPercentCalc3')} % годовых`)
      }
      return result
    },
    {
      scheme: [
        {
          fieldType: 'v-select-radio',
          name: 'agreementPercentCalcType',
          itemText: 'text',
          itemValue: 'value',
          items: [
            {value: 1, text: ' % годовых не зависит от просрочки'},
            {value: 2, text: ' % годовых зависит от просрочки'}
          ],
          sm12: true
        },
        {
          fieldType: 'v-text-field',
          label: 'неустойка за весь период(%)',
          name: 'agreementPercentCalc',
          xs10: true,
          if: notDependOnInterval
        },
        {
          fieldType: 'v-text-field',
          label: 'просрочка (дней)',
          name: 'agreementPercentDays1',
          xs6: true,
          if: dependOnInterval
        },
        {
          fieldType: 'v-text-field',
          label: 'неустойка (%)',
          name: 'agreementPercentCalc1',
          xs6: true,
          if: dependOnInterval
        },
        {
          fieldType: 'v-text-field',
          label: 'просрочка (дней)',
          name: 'agreementPercentDays2',
          xs6: true,
          if: dependOnInterval
        },
        {
          fieldType: 'v-text-field',
          label: 'неустойка (%)',
          name: 'agreementPercentCalc2',
          xs6: true,
          if: dependOnInterval
        },
        {
          fieldType: 'v-text-field',
          label: 'просрочка (дней)',
          name: 'agreementPercentDays3',
          xs6: true,
          if: dependOnInterval
        },
        {
          fieldType: 'v-text-field',
          label: 'неустойка (%)',
          name: 'agreementPercentCalc3',
          xs6: true,
          if: dependOnInterval
        },
        {
          fieldType: 'v-text-field',
          label: '№ пункта договора',
          name: 'agreementPercentCalcTopic',
          xs12: true
        }
      ]
    },
    {
      agreementPercentCalcType: 1,
      agreementPercentCalcTopic: null,
      agreementPercentCalc: null,
      agreementPercentDays1: null,
      agreementPercentCalc1: null,
      agreementPercentDays2: null,
      agreementPercentCalc2: null,
      agreementPercentDays3: null,
      agreementPercentCalc3: null
    }
    ).addToArray(steps)

  const isAgreementDayCalcType2 = (model, field) => model['agreementDayCalcType'] === 2
  const isAgreementDayCalcType3 = (model, field) => model['agreementDayCalcType'] === 3

  new AssistClasses.Step(
    'Укажите, с какого момента следует начислять неустойку и номер пункта договора, в котором указано это условие',
    (step) => {
      if (step.model.agreementDayCalcType === 1) {
        if (step.model.agreementPercentCalc) {
          return ` Неустойка с даты поставки товара`
        }
        return ''
      }
      if (step.model.agreementDayCalcType === 2) {
        return ` Неустойка с даты поставки товара с отсрочкой ${step.formatField('agreementDayDays')} дней`
      }
      var result = ''
      if (step.model.agreementDayDays1) {
        result = `Отсрочка при % ${step.formatField('agreementDayCalc1')} - ${step.formatField('agreementDayDays1')} дней`
      }
      if (step.model.agreementDayDays2) {
        result = `Отсрочка при % ${step.formatField('agreementDayCalc2')} - ${step.formatField('agreementDayDays2')} дней`
      }
      if (step.model.agreementDayDays3) {
        result = `Отсрочка при % ${step.formatField('agreementDayCalc3')} - ${step.formatField('agreementDayDays3')} дней`
      }
      return result
    },
    {
      scheme: [
        {
          fieldType: 'v-select-radio',
          name: 'agreementDayCalcType',
          itemText: 'text',
          itemValue: 'value',
          items: [
            {value: 1, text: ' неустойка начислятся с даты поставки товара'},
            {value: 2, text: ' неустойка начисляется с даты поставки с отсрочкой (дней)'},
            {value: 3, text: ' отсрочка платежа зависит от % от суммы накладной'}
          ],
          sm12: true
        },
        {
          fieldType: 'v-text-field',
          label: 'отсрочка (дней)',
          name: 'agreementDayDays',
          xs10: true,
          if: isAgreementDayCalcType2
        },
        {
          fieldType: 'v-text-field',
          label: '% от суммы',
          name: 'agreementDayCalc1',
          xs6: true,
          if: isAgreementDayCalcType3
        },
        {
          fieldType: 'v-text-field',
          label: 'отсрочка (дней)',
          name: 'agreementDayDays1',
          xs6: true,
          if: isAgreementDayCalcType3
        },
        {
          fieldType: 'v-text-field',
          label: '% от суммы',
          name: 'agreementDayCalc2',
          xs6: true,
          if: isAgreementDayCalcType3
        },
        {
          fieldType: 'v-text-field',
          label: 'отсрочка (дней)',
          name: 'agreementDayDays2',
          xs6: true,
          if: isAgreementDayCalcType3
        },
        {
          fieldType: 'v-text-field',
          label: '% от суммы',
          name: 'agreementDayCalc3',
          xs6: true,
          if: isAgreementDayCalcType3
        },
        {
          fieldType: 'v-text-field',
          label: 'отсрочка (дней)',
          name: 'agreementDayDays3',
          xs6: true,
          if: isAgreementDayCalcType3
        },
        {
          fieldType: 'v-text-field',
          label: '№ пункта договора',
          name: 'agreementDayCalcTopic',
          xs12: true
        }
      ]
    },
    {
      agreementDayCalcType: 1,
      agreementDayCalcTopic: null,
      agreementDayCalc: null,
      agreementDayDays1: null,
      agreementDayCalc1: null,
      agreementDayDays2: null,
      agreementDayCalc2: null,
      agreementDayDays3: null,
      agreementDayCalc3: null
    }
    ).addToArray(steps)

  new AssistClasses.Step(
    'Укажите срок ответа на претензию, если он предусмотрен договором и номер этого пункта договора ',
    (step) => {
      switch (step.model.agreementSumCalcType) {
        case 1:
          return 'С даты направления претензии'
        case 2:
          return 'С даты получения претензии'
      }
    },
    {
      scheme: [
        {
          fieldType: 'v-select-radio',
          name: 'claimResponseDayType',
          itemText: 'text',
          itemValue: 'value',
          items: [
            {value: 1, text: 'срок отсчитывается с даты направления претензии'},
            {value: 2, text: 'срок отсчитывается с даты получения должником претензии'}
          ],
          sm12: true
        },
        {
          fieldType: 'v-text-field',
          label: 'срок ответа (дней)',
          name: 'claimResponseDayValue'
        },
        {
          fieldType: 'v-text-field',
          label: '№ пункта договора',
          name: 'claimResponseDayTopic',
          xs12: true
        }
      ]
    },
    {
      claimResponseDayType: 1,
      claimResponseDayValue: null,
      claimResponseDayTopic: null
    }
    ).addToArray(steps)

  new AssistClasses.Step(
    'Сообщите банковские реквизиты ',
    null,
    {
      scheme: [
        {
          fieldType: 'v-textarea',
          label: 'Банковские реквизиты',
          rows: 5,
          name: 'clientBankAccount',
          xs12: true
        }
      ]
    },
    {
      clientBankAccount: null
    }
    ).addToArray(steps)

  new AssistClasses.Step(
    'Разместите в депозитарии и добавьте ссылки на документы необходимые для оформления претензии ',
    null,
    {
      scheme: []
    },
    {}
    ).addToArray(steps)

  new AssistClasses.Step(
    'Отправьте запрос на подготовку претензии',
    null,
    {
      scheme: []
    },
    {}
    ).addToArray(steps)

  return steps
}

class Model extends AssistClasses.Model {
  constructor () {
    super()
    // step1
    // this.companyInn = null
    // step2
    this.agreementType = 1
    this.agreementName = null
    this.agreementNumber = null
    this.agreementDate = null
    // step3
    this.clientRole = 1
    // step4
    this.invoicesCountType = 1
    // step5
    this.debtType = 1
    // step6
    this.claimIsGoodsReturned = 1
    // step7
    this.claimIsSetOff = 1
    // step8
    this.agreementSumCalcType = 1
    this.agreementSumCalcTopic = null
    // step9
    this.agreementPercentCalcType = 1
    this.agreementPercentCalcTopic = null
    this.agreementPercentCalc = null
    this.agreementPercentDays1 = null
    this.agreementPercentCalc1 = null
    this.agreementPercentDays2 = null
    this.agreementPercentCalc2 = null
    this.agreementPercentDays3 = null
    this.agreementPercentCalc3 = null
    // step10
    this.agreementDayCalcType = 1
    this.agreementDayCalcTopic = null
    this.agreementDayCalc = null
    this.agreementDayDays1 = null
    this.agreementDayCalc1 = null
    this.agreementDayDays2 = null
    this.agreementDayCalc2 = null
    this.agreementDayDays3 = null
    this.agreementDayCalc3 = null
    // step11
    this.claimResponseDayType = 1
    this.claimResponseDayValue = null
    this.claimResponseDayTopic = null
    // step12
    this.clientBankAccount = null
    // step13
  }

  copy () {
    return Object.assign(new Model(), this)
  }

}

class Strategy extends AssistClasses.Strategy {
  createModel () {
    var model = new Model()
    return model
  }
}

function createStrategy (cxt) {
  return new Strategy(cxt)
}

export default {
  createStrategy,
  createSteps,
  Model
}



// WEBPACK FOOTER //
// ./src/components/assist/ClaimSteps.js